import React, { useState, useContext, useEffect } from 'react'
import './services.css'
import Footer from '../../components/footer/Footer'
import Navigation from '../../components/navigation/Navigation'
import ServiceCard from '../../components/serviceCard/ServiceCard'
import servicesData from '../../assets/data/services.json'
import { Col, Row } from 'react-bootstrap'
import { ServicesContext } from '../../contexts/ServicesContext'

function Services() {
    const { services } = useContext(ServicesContext)

    useEffect(() => {
        window.scrollTo(0, 0);
      }, [])
    
    return (
        <div className='services'>
            <Navigation 
                background="theme-color" 
                logo='https://res.cloudinary.com/emacon-production/image/upload/v1654424700/the-outlet/2_cx772d.png' />

            <div className='section-1'>
                <h2>Services</h2>

                <Row className="service_list">
                    {
                        services &&
                        services.map((service, index) => (
                            <Col md={3} key={index}>
                                <ServiceCard service={service} />
                            </Col>
                        ))
                    }
                </Row>
                
            </div>

            <Footer/>
        </div>
    )
}

export default Services
